import styled from "styled-components";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: var(--sab, 0px);
`;

export const PreviewContainer = styled.div(({ theme }) => ({
    width: "calc(100% + 16px)",
    margin: `calc(${theme.spacing.xSmall} * -1)`,
    marginBottom: theme.spacing.empty,
    height: "150px",
    display: "flex",
    overflow: "hidden",
    background: theme.colors[theme.colorMode].background_Subtle,
    borderRadius: `${theme.cornerRadius.large} ${theme.cornerRadius.large} 0 0`,
}));

export const PreviewContent = styled.div(({ theme }) => ({
    width: "50%",
    boxSizing: "border-box",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    padding: `${theme.spacing.large} 0 0 ${theme.spacing.large}`,
    //TODO: add dls value once the design is updated
    color: "#808CBB",
    fontSize: "22px",
    fontStyle: "italic",
    fontWeight: 600,
    lineHeight: "22px",
    letterSpacing: "-0.6px",
}));

export const PreviewImage = styled(Image)(({ theme }) => ({
    width: "50%",
    boxSizing: "border-box",
    wordWrap: "break-word",
    display: "flex",
    justifyContent: "end",
    borderRadius: theme.cornerRadius.xSmall,
}));

export const PredefinedOptionsContainer = styled.div(({ theme }) => ({
    display: "flex",
    gap: theme.spacing.xSmall,
    marginTop: theme.spacing.small,
    marginBottom: theme.spacing.medium,
    overflow: "auto",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
        display: "none",
    },
    "&::-webkit-scrollbar-thumb": {
        display: "none",
    },
}));

export const ButtonContainer = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing.small,
    width: "100%",
    marginTop: theme.spacing.medium,

    "& > div": {
        width: "100%",
    },
}));

export const InstructionsText = styled(Text)(({ theme }) => ({
    padding: theme.spacing.xxSmall,
    paddingTop: theme.spacing.xSmall,
    paddingBottom: theme.spacing.empty,
}));

export const StyledButton = styled(SuperButton)(({ theme }) => ({
    borderRadius: getCornerRadius(theme, "xSmall"),
}));
